module.exports = __webpack_public_path__ + "img/title6.4ece92de.png";